import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Col, Modal as AntModal, Row, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Button } from '../Button/Button';
import styles from './Modal.module.less';
import classnames from 'classnames';

function DefaultFooter({ onClose, footerContent }) {
  const { t } = useTranslation();

  return (
    <Row type="flex">
      <Col xs={24} md={16}>
        {footerContent}
      </Col>
      <Col xs={24} md={8} className={styles.closeButton}>
        <Button block onClick={onClose}>
          {t('general.close')}
        </Button>
      </Col>
    </Row>
  );
}

DefaultFooter.propTypes = {
  onClose: PropTypes.func,
  footerContent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

function DefaultHeader({ onClose, titleText }) {
  return (
    <div className={styles.title}>
      <Typography.Title className={styles.titleContent} level={3}>
        {titleText}
      </Typography.Title>
      <CloseOutlined onClick={onClose} />
    </div>
  );
}

DefaultHeader.propTypes = {
  onClose: PropTypes.func,
  titleText: PropTypes.string
};

function Modal(props) {
  const { footerContent, onClose, children, titleText, className, title, ...rest } = props;
  /**
   * width={'none'} is not valid CSS width value it is set in this way
   *  to make `AntModal` component not override the width from CSS.
   * Otherwise `AntModal` component hardcode the width which will
   *  override any CSS rules as it is set as element style (highest CSS priority).
   */
  return (
    <AntModal
      // width={'none'}
      wrapClassName={styles.wrapContainer}
      className={classnames(styles.modal, className)}
      onCancel={onClose}
      footer={<DefaultFooter onClose={onClose} footerContent={footerContent} />}
      title={title || (titleText && <DefaultHeader onClose={onClose} titleText={titleText} />)}
      maskClosable={false}
      closable={false}
      {...rest}
    >
      {children}
    </AntModal>
  );
}

Modal.propTypes = {
  title: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  titleText: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  footerContent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  footer: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  closable: PropTypes.bool,
  width: PropTypes.number
};

export default Modal;
